import React from 'react';
import PropTypes from 'prop-types';
import './Tooltip.scss';
import clsx from 'clsx';

export default function Tooltip({ children, text, show, title, largeText }) {
  const tooltipClass = clsx('tooltip', { 'large-text': largeText });
  return (
    <div className="tooltip-wrapped">
      {show && (
        <div className={tooltipClass}>
          <div className="tooltip-text-wrapper">
            {title && <span className="tooltip-title">{title}</span>}
            <span className="tooltip-text">{text}</span>
          </div>
        </div>
      )}
      {children}
    </div>
  );
}
Tooltip.defaultProps = {
  show: true,
  largeText: false,
  title: '',
  text: '',
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string,
  show: PropTypes.bool,
  largeText: PropTypes.bool,
  title: PropTypes.string,
};
